<template src="./SignIn.html"/>
<style lang="scss" scoped src="./SignIn.scss"/>

<script>

import {SfAlert, SfCheckbox, SfButton, SfInput, SfLoader, SfLink, SfHeading} from '@storefront-ui/vue';
import OrkToggle from "@/components/Ork/OrkToggle";
import Api from "@/api/Api";
import OrkRecaptcha from "@/components/Ork/OrkRecaptcha";

export default {
  name: "SignIn",
  components: {
    OrkRecaptcha,
    SfCheckbox,
    OrkToggle,
    SfHeading,
    SfAlert,
    SfInput,
    SfButton,
    SfLoader,
    SfLink
  },
  props: {
    showLogin: {type: Boolean, default: true}

  },
  data() {
    return {
      loading: false,
      error: null,
      valid: false,
      createAccount: false,
      submitted: false,
      firstName: "",
      firstNameBlur: true,
      newsLetterSubscribed: false,
      twoFactorAuthenticationEnabled: true,
      lastName: "",
      lastNameBlur: true,
      password: "",
      passwordBlur: true,
      repeatPassword: "",
      repeatPasswordBlur: true,
      email: "",
      emailBlur: true,
      repeatEmail: "",
      repeatEmailBlur: true,
    }
  },
  watch: {
    isLogIn() {
      this.email = ""
      this.repeatEmail = ""
      this.password = ""
      this.createAccount = false
      this.firstName = ""
      this.lastName = ""
    },
  },
  methods: {
    executeRecaptcha() {
      this.$refs.recaptchaSignIn.execute()
    },
    validate() {
      this.firstNameBlur = false;
      this.lastNameBlur = false;
      this.emailBlur = false;
      this.repeatEmailBlur = false;
      this.passwordBlur = false;
      this.repeatPasswordBlur = false;

      if (
          this.validPassword(this.password) &&
          this.validRepeatPassword(this.repeatPassword) &&
          this.validEmail(this.email) &&
          this.validRepeatEmail(this.email, this.repeatEmail) &&
          this.validFirstName(this.firstName) &&
          this.validLastName(this.lastName)
      ) {
        this.valid = true;
      }
    },
    validPassword(password) {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/;
      if (regex.test(password)) {
        return true
      } else {
        return false
      }
    },

    validRepeatPassword(repeatPassword) {
      if (this.password === repeatPassword) {
        return true;
      } else {
        return false
      }
    },

    validRepeatEmail(email, repeatEmail) {
      if (email === repeatEmail) {
        return true;
      } else {
        return false
      }
    },

    validFirstName(firstName) {
      return firstName.length >= 2;
    },

    validLastName(lastName) {
      return lastName.length >= 2;
    },

    validEmail(email) {
      const regex = /(.+)@(.+){2,}\.(.+){2,}/
      const hasWhiteSpace = /\s/;
      if (regex.test(email.toLowerCase()) && !hasWhiteSpace.test(email.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    },

    submitSignInForm(token) {
      const onComplete = () => {
        if (!this.error || this.error.status === 200) {
          this.loading = false;
        } else {
          this.loading = false;
        }
      };

      const onError = (e) => {
        this.error = e;
        this.loading = false;
      };
      this.validate()
      if (this.valid) {
        this.loading = true;
        this.$emit('submit', {
          form: {
            email: this.email,
            firstName: this.firstName,
            lastName: this.lastName,
            password: this.password,
            twoFactorAuthenticationEnabled: this.twoFactorAuthenticationEnabled,
            newsLetterSubscribed: this.newsLetterSubscribed,
            recaptchaData: token
          }, onComplete, onError
        });
      }
    },
  }
}
</script>


